export const STAGE_LABELS = [
  'L1 Gestures',
  'L2 Single words',
  'L3 Two words',
  'L4 Short sentences',
  'L5 Conversations',
];
